import React, { useState, useEffect } from "react";
import { Col, Container, Row, Image, Button } from "react-bootstrap";
import bulb from "../images/landingpages/bulb.svg";
import bulb1 from "../images/landingpages/bulb1.svg";
import student_light from "../images/landingpages/student_light.svg";
import student_light1 from "../images/landingpages/student_light1.svg";
import college_education from "../images/landingpages/college_education.svg";
import college_education1 from "../images/landingpages/college_education1.svg";
import networks_light from "../images/landingpages/networks_light.svg";
import networks_light1 from "../images/landingpages/networks_light1.svg";
import gradientarrow from "../images/landingpages/gradient-arrow.svg";
import men1 from "../images/landingpages/men-1.webp";
import user1 from "../images/landingpages/user1.png";
import user2 from "../images/landingpages/user2.png";
import user3 from "../images/landingpages/user3.png";
import user4 from "../images/landingpages/user4.png";
import shape1 from "../images/landingpages/shape1.svg";
import arrowright from "../images/landingpages/arrow-right.svg";
import topbar from "../images/landingpages/topbar.jpg";
import home1 from "../images/landingpages/home1.jpg";
import logo1 from "../images/landingpages/logo1.png";
import logo2 from "../images/landingpages/logo2.png";
import logo3 from "../images/landingpages/logo3.png";
import logo4 from "../images/landingpages/logo4.png";
import onlineeducation from "../images/landingpages/onlineeducation.svg";
import board from "../images/landingpages/board.svg";
import progresscircle from "../images/landingpages/progresscircle.svg";
import banner1 from "../images/landingpages/banner-1.webp";
import ellipse from "../images/landingpages/ellipse.png";
import PageLoader from "./customcomonents/PageLoader";
import { Link } from "react-router-dom";
import LandingInvitation from "./customcomonents/LandingInvitation";
const LandingHome = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const slides = ["Welcome to BRiDDG", "Your Gateway to College Success"];

  // Automatically change slides every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <React.Fragment>
      <div className="landingpages">
        {true ? (
          <>
            <section className="banner">
              <div className="shapes shape1">
                <Image src={shape1} className="img-fluid" />
              </div>
              <Container>
                <Row className="align-items-center">
                  <Col lg={6} md={6} className="pe-lg-5">
                    <div className="banner-content">
                      <h2>Explore BRiDDG</h2>
                      <div className="topbar_text_slider mb-3">
                        <ul className="custom-slider">
                          {slides.map((slide, index) => (
                            <li
                              key={index}
                              className={`slider-item ${
                                index === activeIndex ? "active" : ""
                              }`}
                            >
                              {slide}
                            </li>
                          ))}
                        </ul>
                      </div>
                      <p>
                        BRiDDG is a supportive community that celebrates the
                        unique journeys and diverse talents of every high school
                        student. We're more than just grades and test scores –
                        we're about showcasing your passions, sharing your
                        voice, and connecting with a community that values who
                        you are.
                      </p>
                      <div className="banner-btns mt-4">
                        <Button
                          as={Link}
                          variant={null}
                          className="btn-learnmore me-3"
                        >
                          Learn More
                        </Button>
                        <Button as={Link}>
                          Get Started{" "}
                          <span>
                            <Image src={arrowright} />
                          </span>
                        </Button>
                      </div>
                    </div>
                  </Col>
                  <Col lg={6} md={6} className="text-center">
                    <div className="banner-img d-inline-block position-relative">
                      <div className="badges badge-users  position-absolute  d-inline-block ">
                        <div className="badges-inner d-inline-flex">
                          <span>
                            <Image src={onlineeducation} />
                          </span>
                          <div className="text-start ms-3">
                            <p className="mb-0">Extracurricular Activities</p>
                          </div>
                        </div>
                      </div>
                      <div className="badges badge-colleges  position-absolute  d-inline-block ">
                        <div className="badges-inner d-inline-flex">
                          <span>
                            <img src={board} />
                          </span>
                          <div className="text-start ms-3">
                            <p className="mb-0">Network with Peers</p>
                          </div>
                        </div>
                      </div>
                      <div className="badges badge-courses position-absolute  d-inline-block">
                        <div className="badges-inner position-relative d-inline-block">
                          <span>
                            <Image src={progresscircle} />
                          </span>
                          <div className="text-center mt-3">
                            <p className="mb-0">Find Your Perfect College</p>
                          </div>
                        </div>
                      </div>
                      <Image src={banner1} className="img-fluid" />
                      <div className="icon-ellipse">
                        <Image src={ellipse} />
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </section>
            <section className="our-goals bg-grey">
              <Container>
                <div className="heading text-center mb-5">
                  <h2 className="mb-3">
                    Navigate Your Journey to College And Beyond
                  </h2>
                  <p>
                    BRiDDG is more than just a platform; it's your launchpad to
                    success. Designed exclusively for high school students,
                    BRiDDG is dedicated to building meaningful connections and
                    creating pathways that lead to college and career
                    opportunities.
                  </p>
                </div>

                <Row>
                  <Col md={6} lg={3} sm={6}>
                    <div className="goals-inner">
                      <div className="goals-icon-text goals-color2">
                        <span>
                          <Image src={bulb} className="img-fluid" />
                          <Image
                            src={bulb1}
                            className="img-fluid"
                            style={{ display: "none" }}
                          />
                        </span>
                        <h2>Resources</h2>
                      </div>
                      <p>
                        Access a wealth of resources to guide your college
                        journey, from study materials to masterclasses and
                        scholarship information
                      </p>
                      <Link className="text-gradient">
                        Learn More{" "}
                        <Image src={gradientarrow} className="img-fluid" />
                      </Link>
                    </div>
                  </Col>
                  <Col md={6} lg={3} sm={6}>
                    <div className="goals-inner">
                      <div className="goals-icon-text goals-color1">
                        <span>
                          <Image src={student_light} className="img-fluid" />
                          <Image
                            src={student_light1}
                            className="img-fluid"
                            style={{ display: "none" }}
                          />
                        </span>
                        <h2>Personal Branding</h2>
                      </div>
                      <p>
                        Build a personal brand that stands out to colleges,
                        showcasing your talents and aspirations.
                      </p>
                      <Link className="text-gradient">
                        Learn More{" "}
                        <Image src={gradientarrow} className="img-fluid" />
                      </Link>
                    </div>
                  </Col>
                  <Col md={6} lg={3} sm={6}>
                    <div className="goals-inner">
                      <div className="goals-icon-text goals-color2">
                        <span>
                          <Image
                            src={college_education}
                            className="img-fluid"
                          />
                          <Image
                            src={college_education1}
                            className="img-fluid"
                            style={{ display: "none" }}
                          />
                        </span>
                        <h2>College Exploration</h2>
                      </div>
                      <p>
                        Explore colleges and find your ideal fit with tools that
                        align with your interests and goals.
                      </p>
                      <Link className="text-gradient">
                        Learn More{" "}
                        <Image src={gradientarrow} className="img-fluid" />
                      </Link>
                    </div>
                  </Col>
                  <Col md={6} lg={3} sm={6}>
                    <div className="goals-inner">
                      <div className="goals-icon-text goals-color3">
                        <span>
                          <Image src={networks_light} className="img-fluid" />
                          <Image
                            src={networks_light1}
                            className="img-fluid"
                            style={{ display: "none" }}
                          />
                        </span>
                        <h2>Networking</h2>
                      </div>
                      <p>
                        Network with like-minded peers, find your support system
                        and build lifelong friendships.
                      </p>
                      <Link className="text-gradient">
                        Learn More{" "}
                        <Image src={gradientarrow} className="img-fluid" />
                      </Link>
                    </div>
                  </Col>
                </Row>
              </Container>
            </section>
            <section className="our-services position-relative">
              <Container>
                <Row className="align-items-center">
                  <Col lg={5} md={5} sm={12} xs={12} className="mt-4 pe-lg-5">
                    <div className="service-img position-relative">
                      <div className="service-img-inner position-relative text-center">
                        <Image src={men1} className="img-fluid" />
                      </div>
                      <div className="peoplesearching position-relative">
                        <h5>56,547+</h5>
                        <p>People are Searching</p>
                        <div className="service-users">
                          <Image src={user1} className="img-fluid" />
                          <Image src={user2} className="img-fluid" />
                          <Image src={user3} className="img-fluid" />
                          <Image src={user4} className="img-fluid" />
                          <span>3+</span>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={7} md={7} sm={12} xs={12} className="mt-4">
                    <div className="services-content">
                      <div className="heading text-start mb-4">
                        <h2>How BRiDDG Works</h2>
                      </div>
                      <p className="para-large">
                        Begin your BRiDDG journey with simple steps that open
                        doors to a world of possibilities. From creating a
                        personalized profile that showcases your unique talents
                        to connecting with a community that supports your
                        educational aspirations.
                      </p>
                      <Button className="mt-4">
                        Get Started Today
                        <span>
                          <Image src={arrowright} />
                        </span>
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Container>
              <div className="shapes shape3">
                <Image src={shape1} className="img-fluid" />
              </div>
            </section>
            <section className="portal position-relative bg-grey">
              <Container>
                <div className="heading text-center mb-5">
                  <h2>Designed with You in Mind</h2>
                </div>
                <div className="portal-inner position-relative">
                  <Image src={topbar} className="img-fluid top-img" />
                  <Image src={home1} className="img-fluid bottom-img" />
                </div>
              </Container>
              <div className="shapes shape4">
                <Image src={shape1} className="img-fluid" />
              </div>
            </section>
            <section className="partners position-relative">
              <Container>
                <Row className="align-items-center">
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <div className="partners-img d-flex flex-row flex-wrap justify-content-between align-items-center">
                      <Image src={logo1} className="img-fluid" />
                      <Image src={logo2} className="img-fluid" />
                      <Image src={logo3} className="img-fluid" />
                      <Image src={logo4} className="img-fluid" />
                    </div>
                  </Col>
                </Row>
              </Container>
            </section>
            <section className="stats-count bg-grey">
              <Container>
                <div className="heading text-center mb-5">
                  <h2 className="mb-3">Ready to Start Your Journey?</h2>
                  <p>
                    Let your unique talents and passions be the key to your
                    dream college. Join BRiDDG to celebrate the real you and
                    unlock new possibilities – are you ready?
                  </p>
                </div>
                <div className="united-inner text-center">
                  <Row className="united-list position-relative justify-content-center">
                    <Col md={4} lg={3} sm={6} className="mb-3">
                      <input type="checkbox" id="checkbox1" name="checkbox" />
                      <label htmlFor="checkbox1">
                        Develop a Strong Personal Brand
                      </label>
                    </Col>
                    <Col md={4} lg={3} sm={6} className="mb-3">
                      <input type="checkbox" id="checkbox2" name="checkbox" />
                      <label htmlFor="checkbox2">
                        Safe and Supportive Environment
                      </label>
                    </Col>
                    <Col md={4} lg={3} sm={6} className="mb-3">
                      <input type="checkbox" id="checkbox3" name="checkbox" />
                      <label htmlFor="checkbox3">
                        Participate in Virtual Events
                      </label>
                    </Col>
                    <Col md={4} lg={3} sm={6} className="mb-3">
                      <input type="checkbox" id="checkbox4" name="checkbox" />
                      <label htmlFor="checkbox4">Stand Out in Admissions</label>
                    </Col>
                    <Col md={4} lg={3} sm={6} className="mb-3">
                      <input type="checkbox" id="checkbox5" name="checkbox" />
                      <label htmlFor="checkbox5">Meet Like-Minded Peers</label>
                    </Col>
                    <Col md={4} lg={3} sm={6} className="mb-3">
                      <input type="checkbox" id="checkbox6" name="checkbox" />
                      <label htmlFor="checkbox6">
                        Access to Exclusive Resources
                      </label>
                    </Col>
                    <Col md={4} lg={3} sm={6} className="mb-3">
                      <input type="checkbox" id="checkbox7" name="checkbox" />
                      <label htmlFor="checkbox7">
                        Masterclasses From Industry Professionals
                      </label>
                    </Col>
                    <Col md={4} lg={3} sm={6} className="mb-3">
                      <input type="checkbox" id="checkbox8" name="checkbox" />
                      <label htmlFor="checkbox8">
                        Peer Collaboration and Group Projects
                      </label>
                    </Col>
                    <Col md={4} lg={3} sm={6} className="mb-3">
                      <input type="checkbox" id="checkbox9" name="checkbox" />
                      <label htmlFor="checkbox9">Connect with Colleges</label>
                    </Col>
                    <Col md={4} lg={3} sm={6} className="mb-3">
                      <input type="checkbox" id="checkbox10" name="checkbox" />
                      <label htmlFor="checkbox10">
                        Showcase Projects and Achievements
                      </label>
                    </Col>
                  </Row>
                  <Button as={Link} to="signup" className="mt-3">
                    Submit
                    <span>
                      <Image src={arrowright} />
                    </span>
                  </Button>
                </div>
              </Container>
            </section>
            <LandingInvitation />
          </>
        ) : (
          <PageLoader />
        )}
      </div>
    </React.Fragment>
  );
};

export default LandingHome;
